"use client"

import { CalendarMinus2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarMinus2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarMinus2Icon = component(Icon)({ as: CalendarMinus2 })
